import { IconTextFormatHeading } from '@components/icons/text-format-heading';
import { getFieldContent } from '@components/text-editors/addons/field-mapping';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';
import { useTextContentActions } from './use-field-actions';
import { FieldMappingDisplay, useFieldMappingEditor } from './use-field-mapping';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'heading'>;

const Display: Config['Display'] = ({ field }) => {
  return <FieldMappingDisplay content={field.label} textProps={{ font: 'heading1' }} />;
};

const FormBuilderHeading: Config['Component'] = ({ field, dragHandle }) => {
  const menuItems = useTextContentActions(field);
  const actions = useFormBuilderContext().store.actions;

  const { shouldUseFieldMapping, FieldMappingEditor } = useFieldMappingEditor({
    field,
    contentKey: 'label',
    sidebarLabel: t('title'),
    fieldType: 'text',
    plaintext: true,
    singleLine: true,
  });

  const editContent = shouldUseFieldMapping ? (
    FieldMappingEditor
  ) : (
    <TextField
      defaultValue={getFieldContent(field.label)}
      label={getFieldContent(field.label)}
      hideLabel
      onChange={actions.createChangeHandler(field, 'label')}
    />
  );

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={editContent}
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Heading',
  },
});

export const headingConfig: Config = {
  kind: 'heading',
  title: t('title'),
  group: 'content',
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={getFieldContent(field.label)} />,
  Icon: IconTextFormatHeading,
  Component: FormBuilderHeading,
  propertiesTabs: [conditionsTab],
};
